import React, { createContext, useEffect, useReducer } from 'react'
import jwtDecode from 'jwt-decode'
import axios from 'axios.js'
import localStorageService from 'app/services/localStorageService'
import { MatxLoading } from 'app/components'
import * as apiroutes from '../../apiroutes'

const initialState = {
    isAuthenticated: false,
    isInitialised: false,
    user: null,
}

const isValidToken = (accessToken) => {
    console.log('checking')
    console.log('checking token JWTAuthContext: ', accessToken)
    if (!accessToken) {
        return false
    }

    const decodedToken = jwtDecode(accessToken)
    const currentTime = Date.now() / 1000
    console.log("decodedToken",decodedToken)
    return decodedToken.exp > currentTime
}

const setSession = (accessToken) => {
    if (accessToken) {
        localStorage.setItem('accessToken', accessToken)
        localStorageService.setItem('userInfo', jwtDecode(accessToken))
        axios.defaults.headers.common.Authorization = `Bearer ${accessToken}`
    } else {
        localStorage.removeItem('accessToken')
        delete axios.defaults.headers.common.Authorization
    }
}

const reducer = (state, action) => {
    switch (action.type) {
        case 'INIT': {
            const { isAuthenticated, user } = action.payload

            return {
                ...state,
                isAuthenticated,
                isInitialised: true,
                user,
            }
        }
        case 'LOGIN': {
            const { user } = action.payload

            return {
                ...state,
                isAuthenticated: true,
                user,
            }
        }
        case 'LOGOUT': {
            return {
                ...state,
                isAuthenticated: false,
                user: null,
            }
        }
        case 'REGISTER': {
            const { user } = action.payload

            return {
                ...state,
                isAuthenticated: true,
                user,
            }
        }
        default: {
            return { ...state }
        }
    }
}

const AuthContext = createContext({
    ...initialState,
    method: 'JWT',
    login: () => Promise.resolve(),
    logout: () => {},
    register: () => Promise.resolve(),
})

export const AuthProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState)

    const login = async (email, password) => {
        const response = await axios.post(apiroutes.LOGIN, {
            email,
            password,
        })
        const { token, userData } = response.data
        // console.log("user", user)
        setSession(token)

        const fullName = `${userData.firstName} ${userData.lastName}`
        console.log("new user", userData)
        const newUser = {
            ...userData,
            name: fullName,
            avatar: '/assets/images/loonsLab.png',
            roles: [userData.role],
        }

        /*
            {
                "id": 1,
                "avatar": "/assets/images/loonsLab.png",
                "email": "superadmin@gmail.com",
                "name": "Super Admin",
                "roles": [
                    "SA"
                ]
            }
        */

        //console.log(newUser);
        dispatch({
            type: 'LOGIN',
            payload: {
                user: newUser,
            },
        })
    }

    const register = async (email, username, password) => {
        // const response = await axios.post('/api/auth/register', {        
        const response = await axios.post(apiroutes.REGISTER, { // TODO - v1 included here
            email,
            username,
            password,
        })

        const { accessToken, user } = response.data

        setSession(accessToken)

        dispatch({
            type: 'REGISTER',
            payload: {
                user,
            },
        })
    }

    const logout = () => {
        setSession(null)
        dispatch({ type: 'LOGOUT' })
    }

    useEffect(() => {
        ;(async () => {
            try {
                const accessToken = window.localStorage.getItem('accessToken')
                if (accessToken && isValidToken(accessToken)) {
                    setSession(accessToken)
                    const response = await axios.get(apiroutes.GETAUTHUSER)
                    let { user } = response.data

                    const fullName = `${user.firstName} ${user.lastName}`
                    user = {
                        ...user,
                        name: fullName,
                        avatar: '/assets/images/avatars/user.png',
                        roles: [user.role],
                    }

                    dispatch({
                        type: 'INIT',
                        payload: {
                            isAuthenticated: true,
                            user,
                        },
                    })
                } else {
                    dispatch({
                        type: 'INIT',
                        payload: {
                            isAuthenticated: false,
                            user: null,
                        },
                    })
                }
            } catch (err) {
                console.error(err)
                dispatch({
                    type: 'INIT',
                    payload: {
                        isAuthenticated: false,
                        user: null,
                    },
                })
            }
        })()
    }, [])

    if (!state.isInitialised) {
        return <MatxLoading />
    }

    return (
        <AuthContext.Provider
            value={{
                ...state,
                method: 'JWT',
                login,
                logout,
                register,
            }}
        >
            {children}
        </AuthContext.Provider>
    )
}

export default AuthContext
